import { render, staticRenderFns } from "./LegacyImportBadge.vue?vue&type=template&id=6dbe1ffc"
import script from "./LegacyImportBadge.vue?vue&type=script&lang=ts&setup=true"
export * from "./LegacyImportBadge.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/PortfolioWeb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6dbe1ffc')) {
      api.createRecord('6dbe1ffc', component.options)
    } else {
      api.reload('6dbe1ffc', component.options)
    }
    module.hot.accept("./LegacyImportBadge.vue?vue&type=template&id=6dbe1ffc", function () {
      api.rerender('6dbe1ffc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ClientScripts/Components/LegacyImportBadge.vue"
export default component.exports